"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var reference_exports = {};
__export(reference_exports, {
  ReferenceNode: () => ReferenceNode
});
module.exports = __toCommonJS(reference_exports);
var import_core = require("@tiptap/core");
var import_utils = require("./utils");
const ReferenceNode = import_core.Node.create({
  name: "reference",
  group: "inline",
  inline: true,
  selectable: true,
  addAttributes() {
    return {
      id: (0, import_utils.getDataAttribute)("id"),
      objectclass: (0, import_utils.getDataAttribute)("objectclass"),
      label: (0, import_utils.getDataAttribute)("label")
    };
  },
  addOptions() {
    return {
      suggestion: { char: "@" },
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        priority: 60,
        tag: 'span[data-type="reference"]',
        getAttrs
      },
      {
        priority: 60,
        tag: 'a[data-type="reference"]',
        getAttrs
      }
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    return [
      "span",
      (0, import_core.mergeAttributes)(
        {
          "data-type": this.name,
          "data-id": node.attrs.id,
          "data-objectclass": node.attrs.objectclass,
          "data-label": node.attrs.label,
          class: "antiMention"
        },
        this.options.HTMLAttributes,
        HTMLAttributes
      ),
      `${this.options.suggestion.char}${node.attrs.label ?? node.attrs.id}`
    ];
  }
});
function getAttrs(el) {
  const id = el.dataset.id?.trim();
  const label = el.dataset.label?.trim();
  const objectclass = el.dataset.objectclass?.trim();
  if (id == null || label == null || objectclass == null) {
    return false;
  }
  return {
    id,
    label,
    objectclass
  };
}
__name(getAttrs, "getAttrs");
//# sourceMappingURL=reference.js.map
